import BigNumber from 'bignumber.js';

/**
 * Check if a value is a valid number
 */
export const isValidNumber = (value) => {
    try {
        const bn = new BigNumber(value);
        return !bn.isNaN() && bn.isFinite();
    } catch {
        return false;
    }
};

/**
 * Format a number to a given precision
 */
export const formatNumber = (value, decimals = 2) => {
    if (!value && value !== 0) return '';

    try {
        const bn = new BigNumber(value);
        if (bn.isNaN() || !bn.isFinite()) return '';

        return bn.toFormat(decimals, {
            decimalSeparator: '.',
            groupSeparator: ',',
            groupSize: 3
        });
    } catch (e) {
        console.error('Error formatting number:', e);
        return '';
    }
};

/**
 * Format a number as currency
 */
export const formatMoney = (value, useCompact = false) => {
    if (!value && value !== 0) return '$0.00';

    try {
        const num = typeof value === 'string'
            ? Number(value.replace(/[^0-9.-]/g, ''))
            : Number(value);

        if (isNaN(num)) return '$0.00';

        // Check if the number is an integer
        const isInteger = Number.isInteger(num);

        if (useCompact && Math.abs(num) >= 1000) {
            return Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                notation: 'compact',
                minimumFractionDigits: 0,
                maximumFractionDigits: 1
            }).format(num).replace(/[KMBTQ]/g, m => m.toLowerCase());
        }

        return Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: isInteger ? 0 : 2,
            maximumFractionDigits: 2
        }).format(num);
    } catch (e) {
        console.error('Error formatting money:', e);
        return '$0.00';
    }
};